<template>
  <!-- 新闻详情 -->
  <div class="NewsDetails" v-loading="loading">
    <div class="cpzx_bj">
      <img src="@/assets/img/spzx_xqy/banner-bg.png" alt="" />
      <ul class="cpzx_bj_text">
        <li>新闻动态</li>
        <li>绿色生态产业链全方位数据专家</li>
        <li></li>
      </ul>
    </div>
    <div class="breadcrumb">
      <div class="breadcrumbBox">
        <img src="@/assets/img/spzx/cpzx_home.png" alt="" />
        <div class="breadcrumbBox_text">
          <span @click="goToHome" class="clickable">首页&nbsp;></span>
          <span @click="goToNews" class="clickable">新闻动态&nbsp;></span>
          <span>新闻详情</span>
        </div>
      </div>
    </div>
    <div class="Solution_box" id="main-content">
      <div class="contentBox">
        <div class="newsDetailBox">
          <div class="contentBox_left">
            <div v-html="innerText"></div>
          </div>
          <div class="contentBox_right">
            <div class="rightTitle">
              <div class="rightTitle_box">
                <img src="@/assets/img/news/xwdt_huo.png" alt="" />
                <div>推荐</div>
              </div>
            </div>
            <ul class="rightContent">
              <li v-for="(item, index) in arr" :key="item.id" @click="handleRecommend(item)">
                <div
                  :class="[
                    index === 0
                      ? 'bs1'
                      : index === 1
                      ? 'bs2'
                      : index === 2
                      ? 'bs3'
                      : ''
                  ]"
                >
                  {{ index + 1 }}
                </div>
                <div>{{ item.name }}</div>
              </li>
            </ul>
            <!-- 推荐新闻分页 -->
            <div class="rightPagination">
              <el-pagination
                class="page"
                layout="prev, next"
                background
                :current-page="recommendPage"
                :page-size="recommendPageSize"
                :total="recommendTotal"
                @current-change="handleRecommendPageChange"
                small
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ArticleCenter from "@/api/articleCenter.js";

export default {
  name: "NewsDetails",
  data() {
    return {
      newsArr: [
        {
          id: "1",
          text: "虫警云数据物联网应用平台在西..."
        },
        {
          id: "2",
          text: "冬春交替时节 设施蔬菜病虫害防..."
        },
        {
          id: "3",
          text: "智慧创新赋能农业发展,华南师大..."
        },
        {
          id: "4",
          text: "虫警云数据物联网应用平台"
        },
        {
          id: "5",
          text: "世界上最坚硬的甲虫,竟能承受自"
        },
        {
          id: "6",
          text: "世界上腿最长的甲虫腿有多长？"
        },
        {
          id: "7",
          text: "如何防治跳甲虫发生"
        },
        {
          id: "8",
          text: "远古发现丨琥珀昆虫标本的肚"
        },
        {
          id: "9",
          text: "世界上最坚硬的甲虫,竟能承受自"
        },
        {
          id: "10",
          text: "虫警云数据物联网应用平台的..."
        },
        {
          id: "11",
          text: "虫警云数据物联网应用平台的..."
        }
      ],
      innerText: "",
      arr: [],
      recommendPage: 1,
      recommendPageSize: 10,
      recommendTotal: 0,
      loading: false
    };
  },
  methods: {
    // 返回首页
    goToHome() {
      this.$LocalCache.setCath("navigationBarIndex", 0);
      this.$router.push({ name: 'Home' });
    },
    // 返回新闻动态
    goToNews() {
      this.$LocalCache.setCath("navigationBarIndex", 3);
      this.$router.push({ name: 'News' });
    },
    // 获取新闻详情
    async getNewsDetail(articleCenterId) {
      this.loading = true;
      try {
        const { code, msg, data } = await ArticleCenter.getDetail({ articleCenterId });
        if (code === 200) {
          this.innerText = data.innerText || '';
          // 等待DOM更新后处理图片
          this.$nextTick(() => {
            this.handleImages();
          });
        } else {
          this.$message.error(msg || '获取新闻详情失败');
        }
      } catch (error) {
        console.error('获取新闻详情失败:', error);
        this.$message.error('获取新闻详情失败');
      } finally {
        this.loading = false;
      }
    },
    // 处理图片尺寸
    handleImages() {
      // 不需要任何JavaScript处理，直接通过CSS统一控制
    },
    async getList() {
      const params = {
        name: "",
        startTime: "",
        endTime: "",
        page: this.recommendPage,
        pageSize: this.recommendPageSize,
        caseType: "",
        articleType: 2
      };
      const { code, msg, data, total } = await ArticleCenter.queryAcList(
        params
      );
      if (code === 200) {
        if (data.length > 0) {
          this.arr = [];
          data.forEach(item => {
            if (item.betterStatus === 1 && item.startStatus === 1) {
              this.arr.push(item);
            }
          });
          this.recommendTotal = total;
        }
      } else {
        this.$message.error(msg);
      }
    },
    handleRecommend(item){
      if (item && item.id) {
        this.$router.push({
          name: "NewsDetails",
          query: {
            articleCenterId: item.id.toString() // 传递文章ID
          }
        });

        // 推荐文章跳转后也滚动到内容区域
        this.$nextTick(() => {
          const mainContent = document.getElementById('main-content');
          if (mainContent) {
            // 计算面包屑导航的高度，确保面包屑显示在视口中
            const breadcrumb = document.querySelector('.breadcrumb');
            const breadcrumbHeight = breadcrumb ? breadcrumb.offsetHeight : 48;
            const bannerHeight = 274; // banner的固定高度

            // 滚动到面包屑导航下方一点点位置，让用户能看到面包屑
            window.scrollTo({
              top: bannerHeight + breadcrumbHeight - 10,
              behavior: 'smooth'
            });
          }
        });
      } else {
        this.$message.error('文章数据异常，无法查看详情');
      }
    },
    // 推荐新闻分页改变
    handleRecommendPageChange(page) {
      this.recommendPage = page;
      this.getList();
    }
  },
  watch: {
    // 监听路由参数变化
    '$route'(to, from) {
      if (to.query.articleCenterId !== from.query.articleCenterId) {
        // 当文章ID变化时，重新获取文章详情
        this.getNewsDetail(to.query.articleCenterId);

        // 路由变化时自动滚动到内容区域
        this.$nextTick(() => {
          const mainContent = document.getElementById('main-content');
          if (mainContent) {
            // 计算面包屑导航的高度，确保面包屑显示在视口中
            const breadcrumb = document.querySelector('.breadcrumb');
            const breadcrumbHeight = breadcrumb ? breadcrumb.offsetHeight : 48;
            const bannerHeight = 274; // banner的固定高度

            // 滚动到面包屑导航下方一点点位置，让用户能看到面包屑
            window.scrollTo({
              top: bannerHeight + breadcrumbHeight - 10,
              behavior: 'smooth'
            });
          }
        });
      }
    }
  },
  mounted() {
    // 获取新闻详情
    const articleCenterId = this.$route.query.articleCenterId;
    if (articleCenterId) {
      this.getNewsDetail(articleCenterId);
    } else {
      this.$message.error('缺少新闻ID参数');
      // 返回新闻动态页面
      this.goToNews();
    }

    // 获取推荐新闻列表
    this.getList();

    // 页面加载后自动滚动到核心内容区域
    this.$nextTick(() => {
      const mainContent = document.getElementById('main-content');
      if (mainContent) {
        // 计算面包屑导航的高度，确保面包屑显示在视口中
        const breadcrumb = document.querySelector('.breadcrumb');
        const breadcrumbHeight = breadcrumb ? breadcrumb.offsetHeight : 48;
        const bannerHeight = 274; // banner的固定高度

        // 滚动到面包屑导航下方一点点位置，让用户能看到面包屑
        window.scrollTo({
          top: bannerHeight + breadcrumbHeight - 10,
          behavior: 'smooth'
        });
      }
    });
  }
};
</script>

<style scoped lang="scss">
.NewsDetails {
  width: 100%;
  .cpzx_bj {
    width: 100%;
    height: 274px;
    position: relative;
    img {
      width: 100%;
      height: 274px;
    }
    .cpzx_bj_text {
      width: 310px;
      height: 134px;
      position: absolute;
      top: 100px;
      left: 50%;
      margin-left: -155px;
      li {
        color: #fff;
        &:nth-child(1) {
          width: 100%;
          height: 56px;
          font-size: 30px;
          padding-left: 68px;
        }

        &:nth-child(2) {
          width: 100%;
          height: 24px;
          font-size: 18px;
        }
        &:nth-child(3) {
          width: 220px;
          height: 4px;
          background-color: #fff;
          margin-top: 22px;
          margin-left: 16px;
          position: relative;
          &:after {
            content: "";
            width: 60px;
            height: 10px;
            background-color: #fff;
            position: absolute;
            top: -3px;
            left: 80px;
          }
        }
      }
    }
  }
  .breadcrumb {
    width: 100%;
    height: 48px;
    display: flex;
    justify-content: center;

    .breadcrumbBox {
      width: 1206px;
      height: 48px;
      font-family: Source Han Sans CN;
      display: flex;
      align-items: center;
      position: relative;

      img {
        width: 22px;
        height: 20px;
      }

      .breadcrumbBox_text {
        position: absolute;
        top: 17px;
        left: 40px;
      }

      span {
        font-size: 16px;

        &:nth-child(1) {
          color: #666666;
        }

        &:nth-child(2) {
          color: #2b8737;
        }

        &:nth-child(3) {
          color: #2b8737;
        }

        &.clickable {
          cursor: pointer;

          &:hover {
            opacity: 0.7;
            text-decoration: underline;
          }
        }
      }
    }
  }
  .Solution_box {
    width: 100%;
    background-color: #f5f5f5;
    padding: 20px 0 36px 0;
    display: flex;
    justify-content: center;
    .contentBox {
      width: 1206px;
      max-width: 100%;
      padding: 0 20px;
      margin: 0 auto;
      .newsDetailBox {
        width: 100%;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        gap: 20px;

        .contentBox_left {
          width: 874px;
          max-width: calc(100% - 330px);
          background-color: #fff;
          padding: 28px;
          min-height: 600px;
          font-size: 16px;
          line-height: 28px;

          // 设置内容区域的统一宽度
          $content-width: 800px;
          $content-width-medium: 700px;
          $content-width-small: 100%;

          // 所有内容元素的基础样式
          :deep(*) {
            box-sizing: border-box;
          }

          // 图片容器样式 - 与文字完全一致的宽度
          :deep(p:has(img)) {
            width: 100%;
            max-width: $content-width;
            margin: 20px auto;
            padding: 0;
            text-align: center;

            img {
              width: 100%;
              height: auto;
              display: block;
              margin: 0;
            }
          }

          // 文字段落样式 - 与图片完全一致的宽度
          :deep(p:not(:has(img))) {
            width: 100%;
            max-width: $content-width;
            margin: 16px auto;
            padding: 0 20px;
            text-align: justify;
            line-height: 1.8;
            box-sizing: border-box;
          }

          // 标题样式 - 与图片文字完全一致的宽度
          :deep(h1, h2, h3, h4, h5, h6) {
            width: 100%;
            max-width: $content-width;
            margin: 20px auto;
            padding: 0 20px;
            box-sizing: border-box;
          }

          // 表格样式 - 与图片文字完全一致的宽度
          :deep(table) {
            width: 100%;
            max-width: $content-width;
            margin: 20px auto;
            box-sizing: border-box;
          }

          // 列表样式 - 与图片文字完全一致的宽度
          :deep(ul, ol) {
            width: 100%;
            max-width: $content-width;
            margin: 16px auto;
            padding: 0 20px;
            box-sizing: border-box;
          }

          // 响应式调整 - 中等屏幕
          @media screen and (max-width: 1200px) {
            padding: 24px;

            :deep(p:has(img)) {
              max-width: $content-width-medium;

              img {
                width: 100%;
              }
            }

            :deep(p:not(:has(img))) {
              max-width: $content-width-medium;
              padding: 0 15px;
            }

            :deep(h1, h2, h3, h4, h5, h6) {
              max-width: $content-width-medium;
              padding: 0 15px;
            }

            :deep(table) {
              max-width: $content-width-medium;
            }

            :deep(ul, ol) {
              max-width: $content-width-medium;
              padding: 0 15px;
            }
          }

          @media screen and (max-width: 992px) {
            max-width: 100%;
            width: 100%;
          }

          // 响应式调整 - 小屏幕
          @media screen and (max-width: 768px) {
            padding: 20px;
            font-size: 14px;
            line-height: 24px;

            :deep(p:has(img)) {
              max-width: $content-width-small;
              margin: 15px auto;

              img {
                width: 100%;
              }
            }

            :deep(p:not(:has(img))) {
              max-width: $content-width-small;
              margin: 12px auto;
              padding: 0 10px;
            }

            :deep(h1, h2, h3, h4, h5, h6) {
              max-width: $content-width-small;
              margin: 15px auto;
              padding: 0 10px;
            }

            :deep(table) {
              max-width: $content-width-small;
            }

            :deep(ul, ol) {
              max-width: $content-width-small;
              padding: 0 10px;
            }
          }
        }

        .contentBox_right {
          width: 310px;
          background-color: #fff;
          align-self: flex-start;

          @media screen and (max-width: 992px) {
            width: 100%;
            max-width: 600px;
            margin: 0 auto;
          }

          .rightTitle {
            width: 100%;
            height: 60px;
            background-color: #1c7e28;
            display: flex;
            justify-content: center;
            align-items: center;
            .rightTitle_box {
              width: 70px;
              height: 24px;
              display: flex;
              img {
                width: 17px;
                height: 21px;
              }
              div {
                font-size: 18px;
                color: #fff;
                height: 24px;
                margin-top: 3px;
                margin-left: 6px;
              }
            }
          }
          .rightContent {
            width: 100%;
            padding: 26px 16px;
            min-height: 400px;
            display: flex;
            flex-direction: column;
            li {
              width: 100%;
              height: 20px;
              display: flex;
              margin-top: 20px;
              &:nth-child(1){
                margin-top: 0 !important;
              }
              &:hover {
                cursor: pointer;
                opacity: 0.7;
              }
              .bs1 {
                background-color: #fd887a !important;
              }
              .bs2 {
                background-color: #fcba59 !important;
              }
              .bs3 {
                background-color: #9fde60 !important;
              }

              div {
                &:nth-child(1) {
                  width: 24px;
                  height: 24px;
                  background-color: #d6d6d6;
                  border-radius: 6px;
                  font-size: 14px;
                  text-align: center;
                  line-height: 24px;
                  color: #fff;
                  flex-shrink: 0;
                }
                &:nth-child(2) {
                  flex: 1;
                  height: 17px;
                  font-size: 16px;
                  margin-top: 3px;
                  margin-left: 4px;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                }
              }
            }
          }

          .rightPagination {
            width: 100%;
            padding: 10px 16px;
            display: flex;
            justify-content: center;

            .page {
              .el-pagination {
                font-size: 12px;
              }

              .el-pagination.is-background .el-pager li:not(.disabled):hover {
                background-color: #1c7e28;
              }

              .el-pagination.is-background .el-pager li:not(.disabled).active {
                background-color: #1c7e28;
              }
            }
          }
        }
      }
    }
  }
}
</style>

<style>
/* 分页组件全局样式 */
.NewsDetails .page .el-pagination.is-background .el-pager li:not(.disabled):hover {
  background-color: #1c7e28 !important;
}

.NewsDetails .page .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #1c7e28 !important;
}

.NewsDetails .page .el-pagination__jump .el-input__inner:focus {
  border-color: #1c7e28 !important;
}

.NewsDetails .page .el-select .el-input.is-focus .el-input__inner {
  border-color: #1c7e28 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/newsDetails/NewsDetails.vue